import type { ComponentProps } from 'react'
import Svg, { Path } from 'react-native-svg'

export function GiftCards(props: ComponentProps<typeof Svg>) {
  return (
    <Svg width={63} height={63} viewBox="0 0 63 63" fill="none" {...props}>
      <Path d="M0 8a8 8 0 018-8h47a8 8 0 018 8v47a8 8 0 01-8 8H8a8 8 0 01-8-8V8z" fill="#C6FFF5" />
      <Path fill="#00DFC9" d="M15.9 20.7001H47.1V29.5001H15.9z" />
      <Path
        d="M44.3 20.3H18.7a3.2 3.2 0 00-3.2 3.2v16a3.2 3.2 0 003.2 3.2h25.6a3.2 3.2 0 003.2-3.2v-16a3.2 3.2 0 00-3.2-3.2zM15.5 28.3h32"
        stroke="#223843"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
